import { useState } from "react";
import { UserName } from "@/components/UserName";
import { draftAct } from "@/components/sales/draft/draftApi";
import { CheckCircle2 } from "lucide-react";

// VERIFY-STATE C (D96): ONE review tick for the values a person entered or the build sheet gave — the photo-read,
// estimated and critical ones each keep their own confirm, so this is never a "confirm all".
export function DraftReview({ v, onView }) {
  const [busy, setBusy] = useState(false);
  const r = v.review;
  return (
    <section data-testid="sales-draft-review" className={`rounded-xl border p-3 space-y-2 text-sm ${r.done ? "border-emerald-200 bg-emerald-50" : "border-slate-200 bg-white"}`}>
      <div className="font-bold text-slate-900">The review</div>
      <p className="text-slate-600">Values entered by a person or from the build sheet, and the words written for the listing: {r.covers.join(", ") || "none yet"}.</p>
      {r.done
        ? <p data-testid="sales-draft-review-done" className="text-emerald-800 inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4" />Reviewed by <UserName email={r.by} /></p>
        : <>
          {r.changed?.length > 0 && <p data-testid="sales-draft-review-changed" className="text-amber-800">Changed since the last review: {r.changed.join(", ")}.</p>}
          {v.can.confirm && <button type="button" data-testid="sales-draft-review-tick" disabled={busy}
            onClick={async () => { setBusy(true); await draftAct(v, "post", "/review", null, onView); setBusy(false); }}
            className="h-11 px-4 rounded-lg bg-[#1F1F1F] text-white font-bold disabled:opacity-40">✓ I've checked these values</button>}
        </>}
    </section>
  );
}

export function DraftBlocks({ blocks }) {
  if (!blocks.length) return <p data-testid="sales-draft-ready" className="rounded-xl border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-900 font-semibold">Nothing stops this listing — it is ready for approval.</p>;
  return (
    <section data-testid="sales-draft-blocks" className="rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm text-amber-950">
      <div className="font-bold">What still stops it going public ({blocks.length})</div>
      <ul className="list-disc pl-5 mt-1 space-y-0.5">{blocks.map((b, i) => <li key={i} data-testid={`sales-draft-block-${b.code}-${i}`}>{b.words}</li>)}</ul>
    </section>
  );
}
